import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCustomers({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/customers`
        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    async insertBatchCustomers({ commit }, data) {
      try {
        console.log(data)
        const url = `/periods/${data.periodId}/unity/${data.unityId}/customers`
        return await api.post(url, data.selectedCustomers)
      } catch (error) {
        throw error
      }
    },
    async insertCustomer({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/registered-customers`
        return await api.post(url, data.client)
      } catch (error) {
        throw error
      }
    },
    async getComplementarInfo({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/registered-customers/${data.customerId}/complementar`
        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    async getRegisteredCustomers({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/registered-customers`
        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    async updateCustomer({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/registered-customers/${data.customerId}`
        return await api.put(url, data.customer)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
